$(function(){
    
    var homeSearch = {
        spaces: [],
        clean: function(arg) {
            return arg.toLowerCase()
            .replace(/[àáâãäå]/g, "a")
            .replace(/[èéêë]/g, 'e')
            .replace(/[îïì]/g, 'i')
            .replace(/[ôöõò]/g, 'o')
            .replace(/[ûüù]/g, 'i')
            .replace(/[ÿ]/g, 'y');
        },
        init: function() {
            var that = this;
            $('.js-space').each(function () {
                var name = $(this).data('name')
                that.spaces.push({
                    search: that.clean(name),
                    obj: $(this)
                })
            });
            $('.js-search').on('keyup', function(event){
                that.search(event, that)
            });
            $('.js-search').parent('form').on('submit', function(e){
                e.preventDefault();
            })
        },
        search: function(event, that) {
            var q = that.clean(event.target.value);
            var hasResults = false;
            that.spaces.map(function(obj){
                var display = obj.search.indexOf(q) > -1;
                if(display){
                    hasResults = true;
                    obj.obj.show();
                }else {
                    obj.obj.hide();
                }
            })
            if(!hasResults){
                $('.js-no-results').show();
            }
            else {
                $('.js-no-results').hide();
            }
        }
    }
    homeSearch.init();
});